import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const IconArrowLink = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconArrowLink;
